import React from "react";
import { Routes, Route } from "react-router-dom";

import Listings from "./pages/Listings";
import Documents from "./pages/Documents";
import Holding from "./pages/Holding";
import ListingDetail from "./pages/ListingDetail";
import Authentication from "./pages/Authentication";
import Inventory from "./pages/Inventory";
import Transactions from "./pages/Transactions";
import RetirementRequests from "./pages/RetirementRequests";
import RetirementHistory from "./pages/RetirementHistory";

import { routes } from "./routes/routes";
import ProtectedRoute from "./components/ProtectedRoute";

import {
  INVENTORY_GET_ROLE,
  TRANSACTIONS_ACCESS_ROLE,
} from "./constants/roles";

import { Auth0ProviderWithNavigate } from "./auth/Auth0ProviderWithNavigate";
import Auth0Initializer from "./auth/Auth0Initializer";
import RouteGuard from "./auth/RouteGuard";

const App = () => {
  return (
    <Auth0ProviderWithNavigate
      domain={window.env.REACT_APP_AUTH0_HOST}
      clientId={window.env.REACT_APP_AUTH0_CLIENT_ID}
      redirectUri={`${window.location.origin}/login`}
    >
      <Auth0Initializer>
        <RouteGuard>
        <Routes>
          <Route path={routes.listing} element={<Listings />} />

          <Route path={routes.listingDetail} element={<ListingDetail />} />

          <Route path={routes.documents} element={<Documents />} />

          <Route path={routes.holding} element={<Holding />} />

          <Route
            path={routes.transactions}
            element={
              <ProtectedRoute
                element={<Transactions />}
                requiredRoles={[TRANSACTIONS_ACCESS_ROLE]}
              />
            }
          />

          <Route path={routes.auth} element={<Authentication />} />

          <Route
            path={routes.inventory}
            element={
              <ProtectedRoute
                element={<Inventory />}
                requiredRoles={[INVENTORY_GET_ROLE]}
              />
            }
          />

          <Route
            path={routes.retirementHistory}
            element={
              <ProtectedRoute
                element={<RetirementHistory />}
                requiredRoles={[INVENTORY_GET_ROLE]}
              />
            }
          />

          <Route
            path={routes.retirementRequests}
            element={<RetirementRequests />}
          />
        </Routes>
        </RouteGuard>
      </Auth0Initializer>
    </Auth0ProviderWithNavigate>
  );
};

export default App;
